import * as React from "react";
import AppHeader from "../AppHeader/AppHeader";
import Box from "@mui/material/Box";
import Footer from "../Footer/Footer";
import { BranchValidator } from "../BranchValidator/BranchValidator";
import { ChatbotPopup } from "../ChatbotPopup/ChatbotPopup";
import { useQuery } from "react-query";
import { ChatbotService } from "gen/clients/llts";
import { useUserSession } from "hooks/useUserSession";

interface Props {
  children: React.ReactNode;
  hideSignInButtonInHeader?: boolean;
}

const PageLayout: React.FC<Props> = ({ children, hideSignInButtonInHeader }) => {
  const { username } = useUserSession();
  const { data: chatbotSettings } = useQuery("getSystemSettings", {
    queryFn: ChatbotService.getChatbotSettings
  });
  return (
    <>
      <BranchValidator />
      <AppHeader hideSignInButton={hideSignInButtonInHeader} />
      <Box sx={{ flex: 1 }}>{children}</Box>
      <Footer />
      {chatbotSettings?.isChatbotHelpCenterEnabled && <ChatbotPopup username={username} />}
    </>
  );
};

export { PageLayout };
